import React from 'react';
import { Search, Filter, X } from 'lucide-react';

const FilterPanel = ({ filters, onFilterChange, boats }) => {
  // Extract unique values for dropdowns
  const models = [...new Set(boats.map(b => b.model).filter(Boolean))].sort();
  const states = [...new Set(boats.map(b => b.locationState).filter(Boolean))].sort();
  const years = [...new Set(boats.map(b => b.year).filter(Boolean))].sort((a, b) => b - a);
  
  const handleChange = (field, value) => {
    onFilterChange({
      ...filters,
      [field]: value
    });
  };

  const clearFilters = () => {
    onFilterChange({
      search: '',
      model: '',
      yearMin: '',
      yearMax: '',
      priceMin: '',
      priceMax: '',
      state: '',
      zipCode: '',
      sortBy: 'price-asc'
    });
  };

  const hasActiveFilters = () => {
    return filters.search || filters.model || filters.yearMin || 
           filters.yearMax || filters.priceMin || filters.priceMax || 
           filters.state || filters.zipCode;
  };

  return (
    <div className="filter-panel">
      <div className="filter-header">
        <h3><Filter size={20} /> Filters</h3>
        {hasActiveFilters() && (
          <button className="clear-filters" onClick={clearFilters}>
            <X size={16} /> Clear All
          </button>
        )}
      </div>

      <div className="filter-section">
        <label>Search</label>
        <div className="search-input">
          <Search size={18} />
          <input
            type="text"
            placeholder="Search boats..."
            value={filters.search}
            onChange={(e) => handleChange('search', e.target.value)}
          />
        </div>
      </div>

      <div className="filter-section">
        <label>Model</label>
        <select
          value={filters.model}
          onChange={(e) => handleChange('model', e.target.value)}
        >
          <option value="">All Models</option>
          {models.map(model => (
            <option key={model} value={model}>{model}</option>
          ))}
        </select>
      </div>

      <div className="filter-section">
        <label>Year Range</label>
        <div className="range-inputs">
          <select
            value={filters.yearMin}
            onChange={(e) => handleChange('yearMin', e.target.value)}
          >
            <option value="">Min</option>
            {years.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
          <span>to</span>
          <select
            value={filters.yearMax}
            onChange={(e) => handleChange('yearMax', e.target.value)}
          >
            <option value="">Max</option>
            {years.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="filter-section">
        <label>Price Range</label>
        <div className="range-inputs">
          <input
            type="number"
            placeholder="Min"
            value={filters.priceMin}
            onChange={(e) => handleChange('priceMin', e.target.value)}
          />
          <span>to</span>
          <input
            type="number"
            placeholder="Max"
            value={filters.priceMax}
            onChange={(e) => handleChange('priceMax', e.target.value)}
          />
        </div>
      </div>

      <div className="filter-section">
        <label>State</label>
        <select
          value={filters.state}
          onChange={(e) => handleChange('state', e.target.value)}
        >
          <option value="">All States</option>
          {states.map(state => (
            <option key={state} value={state}>{state}</option>
          ))}
        </select>
      </div>

      <div className="filter-section">
        <label>Zip Code</label>
        <input
          type="text"
          placeholder="Enter zip code"
          value={filters.zipCode}
          onChange={(e) => handleChange('zipCode', e.target.value)}
          maxLength="10"
        />
      </div>

      <div className="filter-section">
        <label>Sort By</label>
        <select
          value={filters.sortBy}
          onChange={(e) => handleChange('sortBy', e.target.value)}
        >
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
          <option value="year-desc">Year: Newest First</option>
          <option value="year-asc">Year: Oldest First</option>
          <option value="hours-asc">Hours: Low to High</option>
        </select>
      </div>
    </div>
  );
};

export default FilterPanel;
